import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Partner, PartnerDetails, PartnerLocation, PartnerCategory, PagedPartners } from '../models/partners.model';
import { environment } from 'src/environments/environment';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  private url = `${environment.apiUrl}/partners?search=`;
  private urlDetails = `${environment.apiUrl}/partners/`;
  constructor(private http: HttpClient) {}

  getPartners(page: number, limit: number, query?: string, suspended?: boolean): Observable<PagedPartners> {
    let queryString = `page=${page}&limit=${limit}`;
    if (query) {
      queryString += `&search=${query}`;
    }
    // Añadir filtro suspended si se pasa (true/false)
    if (suspended !== undefined && suspended !== null) {
      queryString += `&suspended=${suspended}`;
    }
  
    return this.http.get<PagedPartners>(
      `${environment.apiUrl}/partners?${queryString}`
    );
  }

  updatePartner(partnerId: number, data: any): Observable<Partner> {
    return this.http.put<Partner>(`${environment.apiUrl}/partners/${partnerId}`, data);
  }

  getAllCategories(): Observable<PartnerCategory[]> {
    console.log('getAllCategories method called');
    return this.http.get<PartnerCategory[]>(`${environment.apiUrl}/master/partnerCategories`)
      .pipe(
        tap(categories => console.log('Categories loaded from server', categories)),
        catchError(error => {
          console.log('Error loading categories from server', error);
          throw error;
        })
      );
  }

  createPartner(partner: Partner): Observable<Partner> {
    const url = `${environment.apiUrl}/partners`;
    return this.http.post<Partner>(url, partner);
  }

  editPartner(id: number, partner: Partner): Observable<Partner> {
    console.log('partner in service edit', partner);
    const url = `${environment.apiUrl}/partners/${id}`;
    return this.http.put<Partner>(url, partner);
  }

 

  getPartnerDetails(id: number): Observable<PartnerDetails> {
    return this.http.get<PartnerDetails>(`${this.urlDetails}${id}`);
  }

  addLocation(location: PartnerLocation): Observable<PartnerLocation> {
    const url = `${environment.apiUrl}/partners/locations`;
    return this.http.post<PartnerLocation>(url, location);
  }

  editPartnerLocation(idPartner:number, idLocation: number, location: PartnerLocation): Observable<PartnerLocation> {
    const url = `${environment.apiUrl}/partners/${idPartner}/locations/${idLocation}`;
    return this.http.put<PartnerLocation>(url, location);
  }

}

